import React, { ReactElement } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@hub/accordion'
import { Stack } from '@hub/stack'
import { H5 } from '@hub/heading'
import { Box } from '@hub/box'
import { Pill } from '@hub/pill'

interface FiltersSmall {
  children: ReactElement
  countDisplay: string
  onClick: () => void
}

const FiltersSmall = ({
  children,
  countDisplay,
  onClick,
}: FiltersSmall): JSX.Element => (
  <Accordion
    sx={{
      display: ['block', null, null, 'none'],
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'ghost',
      paddingY: 'spacing-md',
    }}
    allowToggle
  >
    <AccordionItem>
      <AccordionButton
        onClick={() => onClick()}
        sx={{ display: 'block', paddingInlineStart: 0 }}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <H5>Filters</H5>
          <Stack direction={'row'}>
            <Pill>{countDisplay}</Pill>
            <Box sx={{ marginLeft: 'spacing-sm' }}>
              <AccordionIcon />
            </Box>
          </Stack>
        </Stack>
      </AccordionButton>
      <AccordionPanel sx={{ paddingTop: 'spacing-lg' }}>
        {children}
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
)

export default FiltersSmall
